import { useQuery } from '@tanstack/react-query';
import { fetchMyFeatureFlags } from './featureFlags.ts';

/**
 * Whether a feature flag is on for the signed-in user; undefined while loading.
 * `enabled` holds the request back until someone is known to be signed in.
 */
export function useFeatureFlag(flag: string, enabled = true): boolean | undefined {
  const { data } = useQuery({
    queryKey: ['myFeatureFlags'],
    queryFn: fetchMyFeatureFlags,
    enabled,
  });

  return data?.includes(flag);
}
